import { initializeApp } from 'firebase/app'
import { getFirestore, onSnapshot, query, where, collection } from 'firebase/firestore'
import { DataModel } from './DataModel.js'
import { Environment } from './environment'

const dataModel = DataModel
let clickableBtns
let selectedCameraId = ''
let playerPrim = null

window.env = Environment

const firebaseApp = initializeApp(window.env.firebaseConfig)
const db = getFirestore(firebaseApp)

const cameraList = document.getElementById('camera-list')
const selectedSrcId = document.getElementById('selected-src-id')
const selectedSrcName = document.getElementById('selected-src-name')
const selectedSrcUrl = document.getElementById('selected-src-url')
const selectedSrcLink = document.getElementById('selected-src-link')

function normalizeCameraDoc(rawDoc) {
    const srcID = (rawDoc?.srcID ?? '').toString().trim()
    if (!srcID) {
        return null
    }

    return {
        ...rawDoc,
        srcID,
        srcName: (rawDoc?.srcName ?? `(Unnamed ${srcID})`).toString(),
        srcUrl: (rawDoc?.srcUrl ?? '').toString(),
        srcType: (rawDoc?.srcType ?? 'application/x-mpegURL').toString(),
        isViewEnabled: rawDoc?.isViewEnabled === true
    }
}

function buildCameraButtons() {
    let i = 0
    let buttonMarkup = '<h3>Cameras</h3>'

    dataModel.camerasArr.forEach((cam) => {
        const rowNum = i + 1
        const rowLabel = rowNum < 10 ? `0${rowNum}` : `${rowNum}`
        buttonMarkup += `<div class="camera-row"><span class="column">${rowLabel}</span><button class="prim camswitch" id="prim${i}btn" data-id="${cam.srcID}"><span id="${i}led" class="led"></span>${cam.srcName}</button></div>`
        i += 1
    })

    if (i === 0) {
        buttonMarkup += '<p>No camera sources are currently available.</p>'
    }

    cameraList.innerHTML = buttonMarkup
    clickableBtns = document.getElementsByClassName('camswitch')

    for (let idx = 0; idx < clickableBtns.length; idx++) {
        clickableBtns[idx].onclick = handleCameraSelection
    }
}

function updateSelectedCameraDetails(cam) {
    selectedSrcId.textContent = cam.srcID
    selectedSrcName.textContent = cam.srcName
    selectedSrcUrl.textContent = cam.srcUrl || '(none)'
    selectedSrcLink.href = cam.srcUrl || '#'
}

function updateTallyLights() {
    const onLeds = document.querySelectorAll('.led.on')
    for (let i = 0; i < onLeds.length; i++) {
        onLeds[i].classList.remove('on')
    }

    if (!selectedCameraId) {
        return
    }

    const selectedLed = document.querySelector(`[data-id="${selectedCameraId}"] .led`)
    if (selectedLed) {
        selectedLed.classList.add('on')
    }
}

function ensureVideoPlayer() {
    if (playerPrim) {
        return playerPrim
    }

    const optionsPrim = {
        autoplay: true,
        preload: 'auto',
        fluid: true,
        loadingSpinner: false,
        muted: false,
        controls: true,
        aspectRatio: '16:9',
        techOrder: ['html5', 'youtube']
    }

    playerPrim = videojs('vt-preview', optionsPrim)
    playerPrim.on('ended', function onEnded() {
        this.play()
    })

    return playerPrim
}

function updatePreview(cam) {
    const player = ensureVideoPlayer()
    player.src({
        type: cam.srcType,
        src: cam.srcUrl
    })
    player.play()
}

function selectCamera(srcID) {
    const cam = dataModel.cameras[srcID]
    if (!cam) {
        return
    }

    selectedCameraId = srcID
    updateSelectedCameraDetails(cam)
    updateTallyLights()
    updatePreview(cam)
}

function handleCameraSelection() {
    const choice = this.dataset.id
    selectCamera(choice)
}

function chooseInitialCamera() {
    if (selectedCameraId && dataModel.cameras[selectedCameraId]) {
        selectCamera(selectedCameraId)
        return
    }

    const firstCamera = dataModel.camerasArr[0]
    if (firstCamera) {
        selectCamera(firstCamera.srcID)
        return
    }

    selectedCameraId = ''
    selectedSrcId.textContent = '-'
    selectedSrcName.textContent = '-'
    selectedSrcUrl.textContent = '-'
    updateTallyLights()
}

function fetchCameras() {
    dataModel.cameras = {}
    dataModel.camerasArr = []

    const q = query(collection(db, 'Cameras'), where('srcID', '!=', ''))
    onSnapshot(q, (dataSet) => {
        dataSet.docChanges().forEach((docChange) => {
            const data = normalizeCameraDoc(docChange.doc.data())
            if (!data) {
                return
            }

            if (docChange.type === 'added') {
                if (!dataModel.camerasArr.some((x) => x.srcID === data.srcID)) {
                    dataModel.camerasArr.push(data)
                }
                dataModel.cameras[data.srcID] = data
            } else if (docChange.type === 'modified') {
                const index = dataModel.camerasArr.findIndex((x) => x.srcID === data.srcID)
                if (index >= 0) {
                    dataModel.camerasArr[index] = data
                }
                dataModel.cameras[data.srcID] = data
            } else if (docChange.type === 'removed') {
                const index = dataModel.camerasArr.findIndex((x) => x.srcID === data.srcID)
                if (index >= 0) {
                    dataModel.camerasArr.splice(index, 1)
                }
                delete dataModel.cameras[data.srcID]
            }
        })

        dataModel.camerasArr.sort((a, b) => {
            const aName = (a?.srcName ?? '').toString().toLowerCase()
            const bName = (b?.srcName ?? '').toString().toLowerCase()
            if (aName < bName) {
                return -1
            }
            if (aName > bName) {
                return 1
            }
            return 0
        })

        buildCameraButtons()
        chooseInitialCamera()
    })
}

fetchCameras()
